import { type PromoType } from '@hungryroot/rest';

interface CancelWinbackPromo {
  value: string;
  effect: string;
  type: PromoType;
}

interface CancelWinbackPromoData {
  promos: CancelWinbackPromo[];
}

export type Message = {
  [key: string]: CancelWinbackPromoData | boolean | number;
};

declare global {
  interface Window {
    webkit?: {
      messageHandlers: {
        observer: {
          postMessage: (data: Message) => void;
        };
      };
    };
  }
}

export function iosPostMessage(data: Message) {
  return window?.webkit?.messageHandlers?.observer?.postMessage(data);
}
